import React from 'react';
import SliderButton from '@components/common/sliderButton';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const NextArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <SliderButton
      type={'next'}
      slickClass={className}
      handleClick={onClick}
      style={{ ...style }}
      customClassName={cx('btnNext')}
    />
  );
};

export default NextArrow;
